<template>
  <div class="page">
    <div class="box_1">
      <div class="search">
        <div class="input">
          <div class="input_left">
            <span @click="toggleFenlei">{{ chooseName }}</span>
            <span><img src="../../assets/new/drop.svg" alt="" style="margin-left: 4px; width: 10px; height: 10px" /></span>
          </div>
          <div class="input_right">
            <img src="../../assets/new/Frame@2x.png" alt="" />
            <input v-model="courseName" class="search-input" type="text" placeholder="搜索您想要的关键词" @keyup.enter="onChange" />
          </div>
        </div>
        <!-- 控制显示/隐藏 -->
        <div class="fenlei" :class="{ show: isFenleiVisible }">
          <div class="text_7" @click="selectCategory('1')">课程</div>
          <div class="text_7" @click="selectCategory('2')">分类</div>
        </div>
      </div>
      <div class="drop">
        <van-dropdown-menu active-color="#2A70F2 ">
          <van-dropdown-item v-model="value1" :options="codelist" title="选择类目" @opened="open" @change="changeValue" />
          <van-dropdown-item v-model="value2" :options="codelist2" title="选择专业" @opened="open" @change="changeProfessional" />
        </van-dropdown-menu>
      </div>
    </div>
    <div class="group_1">
      <div class="box_2" @click="gotoVip">
        <div class="icon"><img src="../../assets/new/vipbg.png" alt="" /></div>
        <div class="title">
          <div class="text_1" v-if="this.isMember == '01'">开通会员，享受课程资源库免费观看特权</div>
          <div class="text_1" v-if="this.isMember == '02'">恭喜你！！！已开通课程资源库会员特权</div>

          <div class="text_2" v-if="this.isMember == '01'">开通后，会员365天无限量免费观看</div>
          <div class="text_2" v-if="this.isMember == '02'">会员特权截止日期：{{ this.expTime }}</div>

          <div class="btn_1" v-if="this.isMember == '01'">￥365/年</div>
          <div class="btn_1" v-if="this.isMember == '02'" style="background: linear-gradient(90deg, #fdf8ef, #f9dea2); color: #957b5f">
            去续费
          </div>
        </div>
      </div>
      <div class="group_2" v-if="this.isMember == '01'">
        <div class="box_3" v-for="item in courselist" :key="item.id" @click="noVip(item)">
          <div class="image">
            <img :src="item.cImage" alt="铜仁学院省级专业技术人员继续教育培训平台" v-if="item.cImage != '' && item.cImage != null" />
            <img src="../../assets/new/xiaoBg.png" alt="铜仁学院省级专业技术人员继续教育培训平台" v-else />
          </div>
          <div class="title_2">{{ item.cName }}</div>
          <div class="btn_3">
            <div class="text_5">{{ item.cCredithour }}学时</div>
            <div class="btn_4" v-if="item.isBuy == '01'">
              <div class="btn_5" @click.stop="handleDetail(item)">试看</div>
              <div class="btn_6" @click.stop="toPay(item)">购买</div>
            </div>
            <div class="btn_7" v-if="item.isBuy == '02'"><img src="../../assets/new/bofang.png" alt="" /><span>播放</span></div>
          </div>
        </div>
      </div>
      <div class="group_2" v-if="this.isMember == '02'">
        <div class="box_3" v-for="item in courselist" :key="item.id" @click="handleWatch(item)">
          <div class="image">
            <img :src="item.cImage" alt="铜仁学院省级专业技术人员继续教育培训平台" v-if="item.cImage != '' && item.cImage != null" />
            <img src="../../assets/new/xiaoBg.png" alt="铜仁学院省级专业技术人员继续教育培训平台" v-else />
          </div>
          <div class="title_2">{{ item.cName }}</div>
          <div class="btn_3">
            <div class="text_5">{{ item.cCredithour }}学时</div>

            <div class="btn_7"><img src="../../assets/new/bofang.png" alt="" /><span>播放</span></div>
          </div>
        </div>
      </div>
      <div class="load-more">
        <div @click="loadMore" v-if="hasMore" class="more">点击加载更多</div>
        <p v-else>没有更多数据了</p>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toCourseList, getCodeList } from '../../api/vip';
import { toGenerateOrder } from '../../api/classDetail';
import { Dialog } from 'vant';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      codeNo: '',
      courseName: '',
      choose: '1',
      pageNum: 1,
      pageSize: 12,
      courselist: [], //资源库列表
      total: '', //总数据数
      chooseName: '课程', //搜索框分类名
      isFenleiVisible: false,
      hasMore: true,
      codelist: [], //类目列表
      codelist2: [], //专业列表
      isMember: '', //是否是会员
      expTime: '', //会员时间
      value1: '',
      value: '',
      value2: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 显示/隐藏分类
    toggleFenlei() {
      this.isFenleiVisible = !this.isFenleiVisible;
    },
    // 选择课程或分类
    selectCategory(type) {
      this.choose = type;
      // this.courseName=''
      if (this.choose == 1) {
        this.chooseName = '课程';
      } else {
        this.chooseName = '分类';
      }
      this.isFenleiVisible = false;
    },
    loadMore() {
      this.pageNum += 1;
      this.getCourse();
    },
    //跳转vip开通页面
    gotoVip() {
      this.$router.push({
        path: '/vipPage'
      });
    },
    //去试看
    handleDetail(item) {
      this.$router.push({
        path: '/kczyktryPlaying',
        query: { id: item.id }
      });
    },
    //去资源库详情没购买
    // gototdetail(){
    //    this.$router.push({
    //     path: '/resourceDetail',
    //   });
    // },
    //购买
    toPay(item) {
      const data = {
        classIds: '',
        // derateType: '',
        courseIds: item.id,
        equipment: '02'
      };
      toGenerateOrder(data).then(res => {
        if (res.data.data.result == 0) {
          //创建订单失败返回信息
          this.$utils.showToast(res.data.data.msg);
          return false;
        }
        if (res.data.data.result == 1) {
          //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
          let data = res.data.data.order;
          this.$router.push({
            path: '/payType',
            query: data
          });
        }

        //已有订单
        if (res.data.data.result == 3) {
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.msg,
            confirmButtonColor: '#2A70F2'
          })
            .then(() => {
              this.$router.push('/myOrder');
            })
            .catch(() => {
              // this.$utils.showToast('用户点击了取消');
            });
          return false;
        }
      });
    },
    open() {
      this.isFenleiVisible = false;
    },
    //搜索框
    onChange(event) {
      this.courseName = event.target.value;
      if (this.value1) {
        this.getCourse(this.value1);
      } else {
        this.getCourse(this.value2);
      }
      this.isFenleiVisible = false;
    },
    //获取资源库所有分类
    getCode(codeNo) {
      const data = {
        codeNo: codeNo || ''
      };
      getCodeList(data).then(res => {
        this.codelist = res.data.data.map(item => ({
          text: item.CODE_NAME,
          value: item.CODE_NO
        }));
        const children = res.data.data.map(item => item.children);
        this.codelist2 = children.flat().map(item => ({
          text: item.CODE_NAME,
          value: item.CODE_NO
        }));
        console.log(children, '88');
      });
    },
    //选择类目
    changeValue() {
      this.pageNum = 1;
      this.hasMore = true;
      const data = {
        codeNo: this.value1
      };
      if (this.courseName != '') {
        this.courseName = '';
      }
      getCodeList(data).then(res => {
        if (res.data.data) {
          this.codelist2 = res.data.data.map(item => ({
            text: item.CODE_NAME,
            value: item.CODE_NO
          }));
          this.getCourse(this.value1);
        }
      });
    },
    //选择专业
    changeProfessional() {
      this.pageNum = 1;
      this.hasMore = true;
      if (this.courseName != '') {
        this.courseName = '';
      }
      this.getCourse(this.value2);
    },
    noVip(t) {
      //  看是否购买了，购买了跳视频页
      if (t.isBuy == '02') {
        this.$router.push({
          path: '/zykPlayer',
          query: {
            courseId: t.id,
            // classId: item.classId,
            courseWareId: t.cwId,
            courseName: t.cName
          }
        });
      } else {
        this.$router.push({
          path: '/kczyktryPlaying',
          query: { id: t.id }
        });
      }
    },
    //获取资源库列表
    getCourse(codeNo) {
      const token = localStorage.getItem('token') || '';
      const params = {
        token: token,
        codeNo: codeNo || '',
        courseName: this.courseName,
        choose: this.choose,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      toCourseList(params).then(res => {
        if (res.data.data.isMember) {
          this.isMember = res.data.data.isMember;
        } else {
          this.isMember = '01';
        }
        const newCourses = res.data.data.ph.rows;
        this.expTime = res.data.data.expTime;
        if (this.pageNum === 1) {
          window.scrollTo({
            top: 0,
          });
          setTimeout(() => {
            this.courselist = [...newCourses];
          }, 100);
        } else {
          this.courselist = [...this.courselist, ...newCourses];
        }
        this.total = res.data.data.ph.total;
        if (this.courselist.length >= this.total) {
          this.hasMore = false;
        } else {
          this.hasMore = true;
        }
      });
    },
    //去资源库播放页
    handleWatch(item) {
      console.log(item);
      this.$router.push({
        path: '/zykPlayer2',
        query: {
          courseId: item.id,
          // classId: item.classId,
          courseWareId: item.cwId,
          courseName: item.cName
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getCode();
    this.getCourse('09');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  min-height: 100vh;
  overflow-y: scroll;
  padding-bottom: 30px;
}
.group_1 {
  padding: 0 15px;

  // padding-bottom: 30px;
}
.load-more {
  margin-top: 20px;
  text-align: center;
  .more {
    font-size: 14px;
    color: #999;
  }
  p {
    font-size: 14px;
    color: #999;
  }
}
.box_1 {
  height: 102px;
  width: 100%;
  background-color: #fff;
}
.box_2 {
  display: flex;
  width: 100%;
  margin-top: 10px;
  // height: 90px;
  background: #2050d0;
  border-radius: 8px 8px 8px 8px;
  padding: 12px 13px 9px 7px;
  .icon {
    margin-right: 5px;
    display: flex;
    align-items: center;
    img {
      width: 70px;
      height: 65px;
    }
  }
  .title {
    .text_1 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 800;
      font-size: 14px;
      color: #ffffff;
    }
    .text_2 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 2px;
    }
    .btn_1 {
      margin-top: 4px;
      width: 72px;
      height: 26px;
      background: #ffffff;
      border-radius: 13px 13px 13px 13px;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 13px;
      color: #2050d0;
      line-height: 26px;
      text-align: center;
    }
  }
}
.group_2 {
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  .box_3 {
    width: 48%;
    margin-bottom: 10px;
    height: 235px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    .image {
      width: 100%;
      height: 134px;

      img {
        width: 100%;
        height: 134px;
        border-radius: 8px 8px 0px 0px;
      }
    }
    .title_2 {
      // width: 140px;
      min-height: 40px;
      padding: 0 10px 0 0;
      margin-top: 12px;
      margin-left: 10px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      overflow: hidden;
      display: -webkit-box; /* 使用弹性盒模型 */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .btn_3 {
      margin-top: 8px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .text_5 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #656e7e;
      }
      .btn_4 {
        display: flex;
        .btn_5 {
          width: 50px;
          height: 32px;
          background: #f3f3f5;
          border-radius: 27px 0px 0px 27px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          line-height: 32px;
          text-align: center;
          color: #2a70f2;
        }
        .btn_6 {
          width: 50px;
          height: 32px;
          background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
          border-radius: 0px 27px 27px 0px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #ffffff;
          line-height: 32px;
          text-align: center;
        }
      }
    }
  }
}
.search {
  height: 55px;
  padding: 13px 15px 0 15px;
  position: relative;
  .fenlei {
    position: absolute;
    top: 53px;
    left: 17px;
    z-index: 99;
    width: 72px;
    background: #f6f8fa;
    height: auto;
    color: #333;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 0 0 5px 5px;
    .text_7 {
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      &:hover {
        background-color: #eaeaea;
      }
    }
  }

  .fenlei.show {
    display: flex;
  }
  .input {
    // width: 345px;
    background: #f6f8fa;
    border-radius: 8px 8px 8px 8px;
    height: 42px;
    display: flex;
    align-items: center;
  }
  .input_left {
    padding-left: 15px;
    width: 72px;
    border-right: 1px solid #e3e3e3;
  }

  .input_right {
    width: 273px;
    position: relative;
  }
}
.drop {
  width: 100%;
  height: 44px;
}
::v-deep {
  .van-search {
    background-color: #f6f8fa;
    padding: 0;
  }
  .van-cell__title {
    width: auto;
    height: 28px;
    background: #f5f5f5;
    padding: 0 5px;
    text-align: center;
    line-height: 28px;
    border-radius: 4px 4px 4px 4px;
    // -webkit-flex:0;
  }
  .van-dropdown-item__content {
    display: flex;
    flex-wrap: wrap;
    max-height: 196px;
    border-radius: 0px 0px 8px 8px;
  }
  .van-cell {
    width: auto;
    padding: 10px 10px;
  }
  .van-cell::after {
    border: 0;
  }
  .drop {
    .van-cell__value {
      -webkit-box-flex: 0;
      /* -webkit-flex: 1; */
      flex: 0;
    }
  }
  .van-dropdown-menu__bar {
    box-shadow: 0 0 0;
  }
}
.search-input {
  border: 0;
  width: 100%;
  height: 42px;
  background: #f6f8fa;
  border-radius: 8px 8px 8px 8px;
  padding-left: 40px;
  font-size: 14px;
  color: #999;
}
.input_right img {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 53%;
  left: 22px;
  transform: translateY(-50%);
}
.btn_7 {
  width: 74px;
  height: 32px;
  background: #f3f3f5;
  border-radius: 27px 27px 27px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
</style>
